import "./index.scss";

const BulletText = ({ text }) => {
  return (
    <div className="bullet-text">
      <div className="circle" />
      <div className="text">{text}</div>
    </div>
  );
};

export default BulletText;
